// extracted by mini-css-extract-plugin
export default {"fieldset":"Name_fieldset__FWRtC","actions":"Name_actions__GA-jP"};